// src/Icons/GaussIcon.jsx
import React from 'react';

const SimplexIcon = ({ size = 40, className = '' }) => (
  <svg
    viewBox="0 0 100 100"
    width={size}
    height={size}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Dash pattern for feasible region */}
    <defs>
      <pattern
        id="feasibleDash"
        patternUnits="userSpaceOnUse"
        width="8"
        height="8"
      >
        <line
          x1="0"
          y1="8"
          x2="8"
          y2="0"
          stroke="white"
          strokeWidth="2"
        />
      </pattern>
    </defs>

    {/* Cartesian System */}
    <line x1="5" y1="10" x2="5" y2="95" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="2" y1="95" x2="95" y2="95" stroke="#f3f4f6" strokeWidth="6" />

    {/* Constraint lines */}
    <line x1="5" y1="40" x2="95" y2="40" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="60" y1="95" x2="60" y2="5" stroke="#f3f4f6" strokeWidth="6" />
    <line x1="5" y1="15" x2="92" y2="95" stroke="#f3f4f6" strokeWidth="6" />

    {/* Feasible region (dashed fill) */}
    <polygon
      points="5,40 5,95 60,95 60,65 30,40"
      fill="url(#feasibleDash)"
      stroke="#f3f4f6"
      strokeWidth="5"
    />
    {/* Optimal solution point */}
    <circle cx="60" cy="65" r="10" fill="#f3f4f6" />


  </svg>
);

export default SimplexIcon;
